import React, { useEffect, useMemo, useRef, useState } from "react";

import CloseIcon from "../../assets/images/close.png";


import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';



import { connect } from "react-redux";
import { compose } from "redux";


import { addAttachmentAction, editAction, getActionDetails, addActionComment } from "../../store/actions/riskActions";
import { getUsers } from "../../store/actions/adminActions";
import Select, { components } from "react-select";

import moment from 'moment';
import debounce from "lodash/debounce";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: 'none', // Remove the border
        boxShadow: state.isFocused
            ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
            : 'none', // Default to light gray bottom shadow
        backgroundColor: '#EEF0ED',
        padding: 1,
        transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
        '&:hover': {
            boxShadow: state.isFocused
                ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
                : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
        },
    }),

    menu: (provided) => ({
        ...provided,
        border: 'none', // Remove the border around the menu
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3b3b3b'
            : state.isFocused
                ? '#EEF0ED'
                : 'white', // Different background colors for selected, focused, and default
        color: state.isSelected ? 'white' : '#000',
        '&:hover': {
            backgroundColor: '#EEF0ED', // Light background on hover
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),

};

function AddPeopleIcon({ size = 20 }) {
    return (
        <svg
            fill="currentColor"
            aria-hidden="true"
            width={size}
            height={size}
            viewBox="0 0 20 20"
        >
            <path d="M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z" />
        </svg>
    );
}

function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}

export function PeoplePicker({
    users = [],           // [{value, label, avatar}]
    value = [],           // selected [{value, label, avatar}]
    onChange = () => { },
    placeholder = "Owners",
}) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const rootRef = useRef(null);

    // close on outside click
    useEffect(() => {
        function onDocClick(e) {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    const selectedIds = useMemo(() => new Set(value.map((v) => v.value)), [value]);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return users;
        return users.filter(
            (u) =>
                String(u.label).toLowerCase().includes(q) ||
                String(u.value).toLowerCase().includes(q)
        );
    }, [users, query]);

    const selected = value;
    const unselected = filtered.filter((u) => !selectedIds.has(u.value));

    const toggle = (user) => {
        if (selectedIds.has(user.value)) {
            onChange(value.filter((v) => v.value !== user.value));
        } else {
            onChange([...value, user]);
        }
    };

    return (
        <div ref={rootRef} className="relative">
            {/* COMPACT VIEW — avatars only, each with a tiny × to remove; click area opens dropdown */}
            <div className="flex items-center gap-2">
                {/* always-visible Teams add icon */}
                <button
                    type="button"
                    className="w-9 h-9 rounded-full border flex items-center justify-center hover:bg-gray-100 text-gray-700 shrink-0"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((s) => !s);
                    }}
                    aria-expanded={open}
                    aria-label={placeholder}
                    title={placeholder}
                >
                    {/* the exact SVG you provided */}
                    <svg fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z" />
                    </svg>
                </button>

                {/* avatars (overlap), click anywhere else toggles dropdown if you want */}
                <div
                    className="flex items-center"
                    onClick={() => setOpen((s) => !s)}
                    role="button"
                    aria-label="Toggle owners"
                    title="Owners"
                >
                    {selected.length === 0 ? (
                        <div className="ml-0">
                            <Avatar name="No owner" src="" size={28} />
                        </div>
                    ) : (
                        selected.map((u, idx) => (
                            <div className={idx === 0 ? "relative" : "relative ml-1"}>
                                <Avatar name={u.label} src={u.avatar} size={28} />
                                {/* tiny × to remove (doesn't close/open dropdown) */}
                                <button
                                    type="button"
                                    className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white border text-[10px] leading-none flex items-center justify-center hover:bg-gray-100"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // call your toggle/remove
                                        onChange(selected.filter(v => v.value !== u.value));
                                    }}
                                    aria-label={`Remove ${u.label}`}
                                    title={`Remove ${u.label}`}
                                >
                                    ×
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* DROPDOWN — narrower; click row to add/remove; shows Selected then All members */}
            {open && (
                <div className="absolute z-50 mt-2 w-64 rounded-xl border bg-white shadow-xl p-3">
                    <input
                        type="text"
                        placeholder="Search people…"
                        className="w-full border rounded-md px-3 py-2 mb-3 outline-none focus:ring-2 focus:ring-blue-500"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />

                    {selected.length > 0 && (
                        <>
                            <div className="text-xs font-semibold text-gray-500 px-1 mb-1">Selected</div>
                            <ul className="max-h-48 overflow-auto mb-2">
                                {selected.map((u) => {
                                    const isSelected = true;
                                    return (
                                        <li
                                            key={`sel-${u.value}`}
                                            className={`flex items-center justify-between rounded-lg px-2 py-2 cursor-pointer ${isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-gray-50"
                                                }`}
                                            onClick={() => toggle(u)} // click row to remove
                                        >
                                            <div className="flex items-center gap-2">
                                                <Avatar name={u.label} src={u.avatar} size={24} />
                                                <span className="text-sm">{u.label}</span>
                                            </div>
                                            <span className="text-xs text-blue-600">×</span>
                                        </li>
                                    );
                                })}
                            </ul>
                            <div className="h-px bg-gray-200 my-2" />
                        </>
                    )}

                    <div className="text-xs font-semibold text-gray-500 px-1 mb-1">All members</div>
                    <ul className="max-h-64 overflow-auto">
                        {unselected.length === 0 && (
                            <li className="text-sm text-gray-500 px-2 py-2">No matches.</li>
                        )}
                        {unselected.map((u) => {
                            const isSelected = selectedIds.has(u.value);
                            return (
                                <li
                                    key={u.value}
                                    className={`flex items-center justify-between rounded-lg px-2 py-2 cursor-pointer ${isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-gray-50"
                                        }`}
                                    onClick={() => toggle(u)} // click row to add
                                >
                                    <div className="flex items-center gap-2">
                                        <Avatar name={u.label} src={u.avatar} size={24} />
                                        <span className="text-sm">{u.label}</span>
                                    </div>
                                    {/* subtle check on selected (in case filtering brings selected into this list) */}
                                    {isSelected ? <span className="text-xs text-blue-600">✓</span> : null}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}


const ActionOverlay = (props) => {

    const { deleteAttachmentFN , owners, risk_id, editActionFN, profile, closeAction, getActionDetailsFN, action_id, action_details, action_comments, addActionCommentFN, getUsersFN, users, addAttachmentActionFN } = props;


    const fileInputRef = React.useRef(null);

    const handleFileChange = (event, control) => {
        const file = event.target.files[0];
        if (file) {
            addAttachmentActionFN(risk_id, control, file);
        }
    };

    const handleAttachmentClick = (action) => {

        if (formState.Attachment) {
            window.open(formState.Attachment, '_blank');
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };


    const [isLoading, setIsLoading] = useState(true);

    const findOpt = (opts, v) => opts.find(o => o.value === v) || null;
    //////console.log(users);

    const ownerAvatarMap = new Map(
        (Array.isArray(owners) ? owners : []).map(o => [String(o.user_id), o.avatar || ""])
    );

    const listUsers = Array.isArray(users)
        ? users.map(u => {
            const fullName = [u.first_name, u.last_name].filter(Boolean).join(" ");
            return {
                value: u.user_id,
                label: fullName || u.email || `User ${u.user_id}`,
                avatar: ownerAvatarMap.get(String(u.user_id)) || "", // fallback => initials bubble
                email: u.email,
            };
        })
        : [];

    //////console.log(listUsers);

    //const riskResponses = ['Accept', 'Mitigate', 'Transfer', 'Avoid'];




    const [commentState, setCommentState] = useState('');

    const [formState, setFormState] = useState({
        Title: '',
        Definition: '',
        StartDate: '',
        EndDate: '',
        User: [],
        Progress: '',
        Status: '',
        Problem: '',
        Attachment: '',
        Priority: '',


    });



    const listStatus = [{ value: 'Not started', label: 'Not started', color: "#0081A7" }, { value: 'In progress', label: 'In progress', color: "#00AFB9" }, { value: 'Completed', label: 'Completed', color: "#FED9B7" }, { value: 'Problem', label: 'Problem', color: "#F07167" }];

    useEffect(() => {
        //alert(control_id);
        // getRiskFN(risk_id);
        getUsersFN();
        getActionDetailsFN(risk_id, action_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action_id]);


    const calculateDateDifference = (startDate, endDate) => {
        const start = moment(startDate);
        const end = moment(endDate);
        return end.diff(start, 'days') === 0 ? '0 Days Left' : end.diff(start, 'days') + ' Days Left';
    };


    ////console.log(action_comments);

    useEffect(() => {
        if (action_details) {
            const newStatus = listStatus.find(
                (status) => status.value === action_details.progress
            );

            // handle user_id array
            let newUser = null;
            if (Array.isArray(action_details.user_id)) {
                const matched = listUsers.filter((u) =>
                    action_details.user_id.includes(u.value)
                );
                newUser = matched.length ? matched : [];
            } else {
                // fallback for old single-user records
                const single = listUsers.find(
                    (u) => u.value === action_details.user_id
                );
                newUser = single ? [single] : [];
            }

            console.log("action", action_details)

            setFormState({
                ...formState,
                Title: action_details.title,
                Definition: action_details.details,
                StartDate: moment(action_details.start_date).format("YYYY-MM-DD"),
                EndDate: moment(action_details.end_date).format("YYYY-MM-DD"),
                User: newUser, // stays consistent even if multiple
                Progress: action_details.real_progress,
                Status: newStatus,
                Problem: action_details.problem,
                Attachment: action_details.attachment,
                Priority: action_details.priority
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action_details]);

     const handleDeleteAttachment = (attachmentId) => {
        // Call the deleteAttachmentFN action
         setFormState((prev) => ({ ...prev, Attachment: '' }))
    };


    useEffect(() => {
        if (action_details) {
            setIsLoading(false);
        }
    }, [action_details]);


    // eslint-disable-next-line react-hooks/exhaustive-deps

    const handleRiskChange = (data) => {

        setFormState(data);
        //updateServerData(data, "action", null, action_id);

    };



    const disableEvent = React.useCallback(
        (e) => {
            //alert("disableEvent");
            e.persist();

            if (profile.role === "Auditor") {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );


    const initials = (label = "") =>
        label.split(" ").map(s => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

    const MultiValueLabel = (props) => {
        const label = props.data.label;
        return (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{
                    width: 18, height: 18, borderRadius: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 10, fontWeight: 700, border: "1px solid #ddd"
                }}>
                    {initials(label)}
                </div>
                <span>{label}</span>
            </div>
        );
    };

    const OptionWithCheck = (props) => {
        const { isSelected, label } = props;
        return (
            <components.Option {...props}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{
                        width: 16, height: 16, borderRadius: 4,
                        border: "1px solid #bbb",
                        background: isSelected ? "#3b82f6" : "transparent"
                    }} />
                    <div style={{
                        width: 22, height: 22, borderRadius: 9999,
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        fontSize: 10, fontWeight: 700, border: "1px solid #ddd", marginRight: 4
                    }}>
                        {initials(label)}
                    </div>
                    <span>{label}</span>
                </div>
            </components.Option>
        );
    };

    const multiStyles = {
        control: (base) => ({ ...base, minHeight: 42 }),
        multiValue: (base) => ({ ...base, borderRadius: 9999 }),
        multiValueLabel: (base) => ({ ...base, paddingRight: 6 }),
        multiValueRemove: (base) => ({ ...base, borderTopRightRadius: 9999, borderBottomRightRadius: 9999 }),
        option: (base, state) => ({
            ...base,
            paddingTop: 8, paddingBottom: 8,
            backgroundColor: state.isSelected ? "rgba(59,130,246,0.1)" : state.isFocused ? "rgba(0,0,0,0.04)" : "white",
            color: "inherit"
        }),
    };

    const getPriorityColor = (priority) => {
        switch ((priority || "").trim()) {
            case "Critical":
            case "High":
                return "text-red-700";
            case "Medium":
                return "text-orange-600";
            case "Low":
                return "text-yellow-600";
            default:
                return "text-gray-700";
        }
    };

    const DEFAULT_PRIORITY = "Low";
    const [displayPriority, setDisplayPriority] = useState(formState.Priority);

    useEffect(() => {
        if (!formState?.Priority) return;

        // If we're moving to the default (teardown/reset), wait a bit.
        if (formState.Priority === DEFAULT_PRIORITY && displayPriority !== DEFAULT_PRIORITY) {
            const t = setTimeout(() => setDisplayPriority(DEFAULT_PRIORITY), 200); // tweak 120–250ms
            return () => clearTimeout(t);
        }

        // For real user changes (e.g., Low -> High), update immediately.
        setDisplayPriority(formState.Priority);
    }, [formState?.Priority]);




    return (
        <Disable disabled={isLoading} onClick={disableEvent} onKeyDown={disableEvent}>
            <div style={profile.role === "Auditor" ? { pointerEvents: 'none', userSelect: 'none' } : { pointerEvents: 'auto', userSelect: 'auto' }}>
                <div className={`p-10 bg-white rounded-lg`}>
                    <div className="flex justify-between items-center mb-3 relative">
                        <h1 className={`text-md font-semibold ${getPriorityColor(displayPriority)}`}>
                            {displayPriority}
                        </h1>

                        <img
                            src={CloseIcon}
                            alt="Close"
                            className="w-6 h-6 cursor-pointer absolute top-2 right-2"
                            onClick={() => closeAction(formState, action_id)}
                        />
                    </div>
                    {/* Title and Definition */}
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[#3b3b3b] mb-1 text-sm">Title</label>
                    </div>

                    <div className="mb-3">
                        {/* Title input */}
                        <input
                            type="text"
                            placeholder="Title"
                            value={formState.Title}
                            onChange={(e) =>
                                handleRiskChange({ ...formState, Title: e.target.value })
                            }
                            className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500"
                            style={{
                                border: "none",
                                backgroundColor: "#EEF0ED",
                                padding: "8px 10px",
                                outline: "none",
                                transition: "box-shadow 0.1s ease",
                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                            }}
                            onFocus={(e) =>
                                (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                            }
                            onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                        />

                        {/* Definition textarea */}
                        <textarea
                            placeholder="Definition"
                            value={formState.Definition}
                            onChange={(e) =>
                                handleRiskChange({ ...formState, Definition: e.target.value })
                            }
                            className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500 mt-2"
                            style={{
                                border: "none",
                                backgroundColor: "#EEF0ED",
                                padding: "8px 10px",
                                outline: "none",
                                resize: "vertical",
                                transition: "box-shadow 0.1s ease",
                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                            }}
                            onFocus={(e) =>
                                (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                            }
                            onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                        />
                    </div>



                    <div className="flex justify-start items-center w-full mt-4 mb-4">
                        <PeoplePicker
                            users={listUsers}
                            value={Array.isArray(formState.User) ? formState.User : []}
                            onChange={(arr) => setFormState((prev) => ({ ...prev, User: arr }))}
                            placeholder="Owners"
                        />
                    </div>

                    <div className="grid grid-cols-4 gap-4 mb-6">
                        {/* Start Date */}
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Start Date</label>
                            <input
                                type="date"
                                placeholder="Start Date"
                                className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500"
                                style={{
                                    border: "none",
                                    backgroundColor: "#EEF0ED",
                                    padding: "8px 10px",
                                    outline: "none",
                                    transition: "box-shadow 0.1s ease",
                                    boxShadow: "inset 0 0 0 0 #3b3b3b",
                                    height: "36px",
                                }}
                                value={formState.StartDate || ""}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, StartDate: e.target.value })
                                }
                                onFocus={(e) =>
                                    (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                                }
                                onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                            />
                        </div>

                        {/* End Date */}
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-1 text-sm">End Date</label>
                            <input
                                type="date"
                                placeholder="End Date"
                                className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500"
                                style={{
                                    border: "none",
                                    backgroundColor: "#EEF0ED",
                                    padding: "8px 10px",
                                    outline: "none",
                                    transition: "box-shadow 0.1s ease",
                                    boxShadow: "inset 0 0 0 0 #3b3b3b",
                                    height: "36px",
                                }}
                                value={formState.EndDate || ""}
                                onChange={(e) =>
                                    handleRiskChange({ ...formState, EndDate: e.target.value })
                                }
                                onFocus={(e) =>
                                    (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                                }
                                onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                            />
                        </div>

                        {/* Days Left */}
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Days Left</label>
                            <input
                                type="text"
                                placeholder="Days Left"
                                className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500"
                                style={{
                                    border: "none",
                                    backgroundColor: "#EEF0ED",
                                    padding: "8px 10px",
                                    outline: "none",
                                    transition: "box-shadow 0.1s ease",
                                    boxShadow: "inset 0 0 0 0 #3b3b3b",
                                    height: "36px",
                                }}
                                value={
                                    formState.StartDate && formState.EndDate
                                        ? calculateDateDifference(formState.StartDate, formState.EndDate)
                                        : ""
                                }
                                disabled
                            />
                        </div>
                    </div>






                    <div className="grid grid-cols-4 gap-4 mb-6">
                        {/* Progress */}
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Progress</label>

                            <div className="relative w-[160px] h-6 bg-gray-200 rounded-full flex items-center">
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={formState.Progress || 0}
                                    onChange={(e) =>
                                        handleRiskChange({ ...formState, Progress: e.target.value })
                                    }
                                    className="absolute w-[160px] h-6 appearance-none bg-transparent rounded-full cursor-pointer"
                                    style={{
                                        background: `linear-gradient(to right, #09A6B0 ${formState.Progress || 0}%, #f07167 ${formState.Progress || 0}%)`,
                                    }}
                                />
                                <span className="relative text-white text-[13px] font-semibold ml-2">
                                    {formState.Progress || 0}%
                                </span>
                            </div>
                        </div>
                        {/* Status */}
                      

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">Status</label>
                            <Select
                                options={listStatus}
                                placeholder="Status"
                                value={formState.Status}                              // option object
                                onChange={(opt) => handleRiskChange({                 // store STRING only
                                    ...formState,
                                    Status: opt
                                })}
                                styles={customStyles}
                                className="text-sm"
                            />
                        </div>
                    </div>


                    {formState.Status.value === 'Problem' && (
                        <textarea
                            placeholder="Problem"
                            value={formState.Problem}
                            onChange={(e) =>
                                handleRiskChange({ ...formState, Problem: e.target.value })
                            }
                            className="w-full text-[13px] rounded bg-[#EEF0ED] text-black placeholder-gray-500 mt-2"
                            style={{
                                border: "none",
                                backgroundColor: "#EEF0ED",
                                padding: "8px 10px",
                                outline: "none",
                                resize: "vertical",
                                transition: "box-shadow 0.1s ease",
                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                            }}
                            onFocus={(e) =>
                                (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                            }
                            onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                        />
                    )}



                    {/* Risk Owner, Department, Status, Definition Date */}
                    <div className="grid grid-cols-4 gap-4 mb-6">
                        {/* Attachments column */}
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-1 text-sm">Attachments</label>
                            {formState.Attachment && (
                                <ul className="mt-2">
                                    <li className="flex justify-between items-center bg-[#EEF0ED] border border-gray-200 rounded p-4 my-4 max-w-sm hover:bg-[#E5E7E4] shadow-sm">
                                        <a
                                            href={formState.Attachment}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-[#3b3b3b] hover:underline flex-1 text-sm"
                                        >
                                            {formState.Attachment.length > 36
                                                ? `${formState.Attachment.slice(0, 36)}...`
                                                : formState.Attachment}
                                        </a>
                                        <button
                                            className="text-black ml-2"
                                            onClick={() => handleDeleteAttachment(formState.Attachment)}
                                        >
                                            <TfiTrash size={16} />
                                        </button>
                                    </li>
                                </ul>
                            )}

                            <button
                                className="bg-white text-black text-sm border border-gray-100 py-2 px-2 rounded hover:bg-gray-100 shadow-md"
                                onClick={() => fileInputRef.current.click()}
                            >
                                Add Attachment
                            </button>

                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={(event) => handleFileChange(event, action_id)}
                            />
                        </div>
                    </div>



                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">Comments</h3>

                    {/* Comments */}
                    <div className="mb-6">
                        <textarea
                            placeholder="Comments"
                            className="w-full text-sm rounded bg-[#EEF0ED] text-black placeholder-gray-500"
                            style={{
                                border: "none",
                                backgroundColor: "#EEF0ED",
                                padding: "8px",
                                outline: "none",
                                transition: "box-shadow 0.1s ease",
                                boxShadow: "inset 0 0 0 0 #3b3b3b",
                            }}
                            onFocus={(e) =>
                                (e.target.style.boxShadow = "inset 0 -2px 0 0 #3b3b3b")
                            }
                            onBlur={(e) => (e.target.style.boxShadow = "inset 0 0 0 0 #3b3b3b")}
                            value={commentState}
                            onChange={(e) => setCommentState(e.target.value)}
                        />

                        <div className="flex justify-end mt-4">
                            <button
                                className="bg-[#3b3b3b] text-white py-2 px-4 text-sm rounded hover:bg-opacity-70"
                                onClick={() => {
                                    if (commentState) {
                                        addActionCommentFN(commentState, action_id);
                                        setCommentState("");
                                    }
                                }}
                            >
                                Add Comment
                            </button>
                        </div>
                    </div>

                    {/* Mark Jones Comment */}

                    {
                        action_comments && action_comments?.length > 0 && action_comments.map((comment, index) => (
                            <div className="bg-[#EEF0ED] p-4 rounded-[5px] text-gray-600 mb-4">
                                <div className="flex justify-between">
                                    <span className="font-semibold">{comment.FirstName} {comment.LastName}</span>
                                    <span>{moment(comment.CommentDate).format('MM/DD/YYYY HH:mm:ss')}</span>
                                </div>
                                <p className="mt-2">{comment.CommentText}</p>
                            </div>
                        ))
                    }


                </div >
            </div>
        </Disable >
    );
};


const mapStateToProps = (state) => {
    console.log("Action ", state.risk.action_details)
    return {

        risk: state.risk.risk,
        profile: state.profile.profile,
        action_details: state.risk.action_details,
        action_comments: state.risk.action_comments,
        users: state.admin.admin_users,
        owners: state.risk.action_details?.owners,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAttachmentActionFN: (risk_id, action_id, file) => dispatch(addAttachmentAction(risk_id, action_id, file)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        getActionDetailsFN: (risk_id, action_id) => dispatch(getActionDetails(risk_id, action_id)),
        addActionCommentFN: (comment, action_id) => dispatch(addActionComment(comment, action_id)),
        getUsersFN: () => dispatch(getUsers()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ActionOverlay);